import React from 'react';
import { MailFill } from 'sushiweb/Icons';
import { CopyText } from '../../../../UiKit';
import { grey } from 'sushiweb/tokens/color';
import { viewText } from '../../../../images/images';

export const UserEmail = ({ emailInfo = null, onClick = () => {} }) => {
  return (
    <div>
      <span className='iconMarginR'>
        <MailFill size={14} color={grey.z500} />
      </span>
      {emailInfo ? (
        <CopyText type='email' title={emailInfo.email} masking={false} />
      ) : (
        <div className='masked'>
          xxxxxxx
          <span className='pointer icon iconMarginL' onClick={onClick}>
            <img src={viewText} alt='' />
          </span>
        </div>
      )}
    </div>
  );
};
